export enum CPortalLayer {
  Select = 'c-portal-select',
  Tooltip = 'c-portal-tooltip',
  Popover = 'c-portal-popover',
  Modal = 'c-portal-modal',
  SidePanel = 'c-portal-side-panel',
  BottomPanel = 'c-portal-bottom-panel',
  Notifications = 'c-portal-notifications',
}
